import { reducerFactory } from 'common/store/scope';

import search from 'common/store/search/advanced/reducer';

import {
  NAMESPACE,
} from './actions';

export default reducerFactory(NAMESPACE, search);
